<template>
    <v-row justify="center">
    <v-dialog v-model="abrir" persistent max-width="600px" height="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{configuracion.titulo}}</span>
          
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                    <v-autocomplete
                        v-model="seleccionados"
                        :items="usuarios"
                        item-text="name"
                        item-value="id"
                        dense
                        chips
                        small-chips
                        label="Seleccione Usuarios"
                        multiple
                        :deletable-chips="true"
                        solo
                    ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" dark @click="abrir = false">Cancelar</v-btn>
          <v-btn color="green darken-1" dark @click="confirmar">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
export default {
    data:()=>({
        abrir:false,
        configuracion:{},
        usuarios:[],
        seleccionados:[],
        item:{},
    }),
    beforeDestroy() {
        Event.$off('abrir_asignar_usuario');
    },
    mounted(){
        Event.$on('abrir_asignar_usuario',(configuracion,seleccionados,item)=>{
            // this.cargarUsuarios();
            this.configuracion = configuracion;
            this.seleccionados = seleccionados;
            this.item = item;
            this.abrir = true;
        });

        this.cargarUsuarios();

    },
    methods: {
        async cargarUsuarios(){
            let url = `${this.base_url}user`;
            this.axios.get(url,this.headers).then((response)=>{
                console.log('usuarios',response.data.data);
                this.usuarios = response.data.data;
            }).catch((error)=>{
                console.log('error',error);
            })            
        },

        confirmar(){
            console.log('guardando',this.seleccionados);
            console.log('item',this.item);
            let url = `${this.base_url}parametro_detalles/${this.item.id}/asignar_usuarios`;
            let body = {
                usuarios:this.seleccionados,
            }
            this.mostrarLoading({titulo:'Actualizando Usuarios de Alarmas...',color:'green'})
            this.axios.put(url,body,this.headers).then((response)=>{
                console.log('se actualizaron los usuarios',response);
                this.$emit('peticionrealizada');
                this.limpiar();
                this.ocultarLoading();
            }).catch((error)=>{
                this.limpiar();
                this.ocultarLoading();
            });
        },
        limpiar(){
            this.abrir = false;
            this.configuracion = {};
            // this.usuarios = [];
            this.seleccionados = [];
            this.item = {};
        },
        ...mapMutations(['mostrarLoading','ocultarLoading']),
    },
    computed:{
        ...mapState(['base_url','headers'])
    }
}
</script>